module.exports = __webpack_public_path__ + "img/ico-album.830774dd.svg";